enum LabProcessingStatusFilterOption {
    PendingCancelled = 1,
    Partial,
    Preliminary,
    Final,
    Other
}

export { LabProcessingStatusFilterOption };
